import { createFetcher } from './Fetcher';

export default createFetcher(({ pageSettingsStore }, { showId }) => ({
    fetch: () => showId && pageSettingsStore.fetchSettings(showId),
    isLoading: pageSettingsStore.fetchSettings.pending,
    input: [showId],
}));
